import { IconCircleCheckFilled } from "@tabler/icons-react";
import { usePrvTranslation } from "#/pages/ClientDetail/components/prv/usePrvTranslation";
import type { HealthCheckKey } from "#/types/dataHealth";

interface Props {
  keys: HealthCheckKey[];
}

/** The checks that found nothing, so the reader knows what was verified, not only what failed. */
const PassingChecks = ({ keys }: Props) => {
  const t = usePrvTranslation();
  if (keys.length === 0) return null;

  return (
    <section className="flex flex-col gap-3 rounded-xl border border-gray-200 bg-white p-5">
      <h3 className="text-sm font-semibold text-gray-900">
        {t("dataHealth.passing.title", { count: keys.length })}
      </h3>
      <ul className="flex flex-wrap gap-2">
        {keys.map((key) => (
          <li
            key={key}
            className="inline-flex items-center gap-1.5 rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-1 text-xs text-emerald-900"
          >
            <IconCircleCheckFilled size={14} className="text-emerald-600" />
            {t(`dataHealth.checks.${key}.title`)}
          </li>
        ))}
      </ul>
    </section>
  );
};

export default PassingChecks;
